import { useMemo } from 'react';

import VBaseTableContext from './context';
import type {
  VBaseTableContextValue,
  VBaseTableData,
  VBaseTableProps,
} from './type';

export const useDefaultColumnList = <T extends VBaseTableData>(
  columnList: VBaseTableProps<T>['columnList'],
  data: VBaseTableProps<T>['data'],
) => {
  const defaultColumnList = useMemo(
    () =>
      columnList?.length
        ? columnList
        : data?.length
          ? Object.keys(data[0])
          : [],
    [columnList, data],
  );

  return defaultColumnList;
};

export const useVBaseTableContext = <T extends VBaseTableData>() =>
  VBaseTableContext.hook() as VBaseTableContextValue<T>;
